import React from 'react';
import logo from '../assets/logo.png';

export default function ExperienceSection() {
    return (
        <section className="experience-section">
            <div className="experience-container">
                <div className="experience-image-wrapper">
                    <img src={logo} alt="Swaimsidh Marble" className="experience-badge" />
                </div>
                <div className="experience-content">
                    <h2>20 Years of <br />Expertise</h2>
                    <p>
                        Swaimsidh Marble brings you premium marble from India and across the world.
                        We specialize in design, supply, and installation for residential and commercial projects.
                    </p>
                </div>
            </div>
        </section>
    );
}
